import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';

import { useAuth } from '../../../common/hooks/useAuth';
import { useNavigation } from '../../../common/navigation';
import { Role } from '../../../common/spdCore/authorization/roles';

export const CompanyInvoicesLink = (props: {
  companyId: string;
  companyName?: string | null;
}) => {
  const auth = useAuth();
  const nav = useNavigation();

  if (!auth.check([Role.Admin, Role.Finance])) {
    return null;
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div onClick={e => e.stopPropagation()}>
      <OverlayTrigger overlay={<Tooltip>Nieopłacone faktury firmy</Tooltip>}>
        <Button
          variant="outline-primary"
          onClick={() =>
            nav.companyOverdueInvoices(
              props.companyId,
              props.companyName || '',
              true,
            )
          }
        >
          Nieopłacone faktury
        </Button>
      </OverlayTrigger>
    </div>
  );
};
